var _defs, _g, _rect, _g2, _path, _g3, _path2, _path3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipmentfacto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo-CostCalculator",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #2ca97c;\n      }\n\n      .st1 {\n        fill: #064b93;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        fill: #6ebc81;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-CostCalculator1",
    "data-name": "Logo-CostCalculator"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1425",
    className: "st1",
    d: "M0,62.3h104v32c0,5.5-4.5,10-10,10H10c-5.5,0-10-4.5-10-10v-32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1426",
    className: "st3",
    d: "M104,62.3H0V10.3C0,4.8,4.5.3,10,.3h84c5.5,0,10,4.5,10,10v52h0Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 34.1,
    y: 62.3,
    width: 23.8,
    height: 6.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14261",
    "data-name": "Rectangle_1426"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104,62.3H0V10.3C0,4.8,4.5.3,10,.3h84c5.5,0,10,4.5,10,10v52h0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.6,49.8v-6.4h-6.4v-4.3h6.4v-6.4h4.3v6.4h6.4v4.3h-6.4v6.4h-4.3ZM33.6,26.3h34.2-34.2ZM37.9,49.8v-8.6h-8.6v-12.8c0-1.8.6-3.3,1.9-4.6,1.2-1.2,2.8-1.8,4.5-1.8h30c1.8,0,3.3.6,4.6,1.8s1.8,2.8,1.8,4.6v1.7c-.6-.4-1.3-.7-2-.9s-1.5-.5-2.2-.6c0-.6-.2-1.2-.6-1.6s-.9-.7-1.5-.7h-30c-.6,0-1.1.2-1.5.6s-.6.9-.6,1.5v8.6h4.3v-4.3h18.3c-.6.6-1.1,1.3-1.5,2s-.8,1.5-1.1,2.3h-11.4v8.6h11.4c.2.8.6,1.5,1.1,2.2s1,1.4,1.5,2h-18.3ZM59.3,22v-6.4h-17.1v6.4h-4.3v-10.7h25.7v10.7h-4.3Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.5,90.2v3.6h-17.3v-23.1h16.9v3.6h-12.6v6h11.2v3.5h-11.2v6.4h13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.6,96.1c-1.5,1.8-3.6,2.7-6,2.7s-5.5-1.2-8.9-4.8c-6.5-.6-11.1-5.4-11.1-11.8s5.3-11.9,12.4-11.9,12.4,5,12.4,11.9-3.5,9.9-8.6,11.4c1.3,1.4,2.5,1.9,3.9,1.9s2.8-.6,4-1.8l2,2.4ZM63,90.4c4.7,0,8.1-3.4,8.1-8.1s-3.5-8.1-8.1-8.1-8.1,3.4-8.1,8.1,3.5,8.1,8.1,8.1Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.4,64.6l-4.6,4.8c-.2.2-.6.2-.8,0L0,33.4v-9.9l43.4,41.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.4,71.5l-4.4,4.6c-.2.2-.6.2-.8,0L0,53.2v-9.4s29.4,27.7,29.4,27.7Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14261"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94,2.3c4.4,0,8,3.6,8,8v50H2V10.3C2,5.9,5.6,2.3,10,2.3h84M94,.3H10C4.5.3,0,4.8,0,10.3v52h104V10.3c0-5.5-4.5-10-10-10h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentfacto);
export default __webpack_public_path__ + "static/media/equipmentfacto.ba1522b883bd113196cd352a05c3354e.svg";
export { ForwardRef as ReactComponent };